/* global $ */
import React, { useState, useEffect, useRef } from 'react';
import axiosInstance from "../axiosInstance";
import Swal from "sweetalert2";
import Footer from '../components/Footer';

function Employee() {

    const [employees, setEmployees] = useState([]); // Store product data
    const [isDataTableInitialized, setIsDataTableInitialized] = useState(false);

    useEffect(() => {
        if (employees.length > 0 && window.$) {
            let $ = window.$;

            if (isDataTableInitialized) {
                $(".datatable").DataTable().destroy();
            }

            $(".datatable").DataTable({
                "bFilter": false,
                "autoWidth": false,
                "sDom": "fBtlpi",
                "ordering": true,
                "columnDefs": [{ "targets": "no-sort", "orderable": false }],
                "language": {
                    search: " ",
                    sLengthMenu: "_MENU_",
                    paginate: {
                        next: 'Next <i className="fa fa-angle-double-right ms-2"></i>',
                        previous: '<i className="fa fa-angle-double-left me-2"></i> Previous',
                    },
                },
                initComplete: function () {
                    $(".dataTables_filter").appendTo("#tableSearch");
                    $(".dataTables_filter").appendTo(".search-input");
                },
            });

            setIsDataTableInitialized(true); // Mark DataTable as initialized
        }
    }, [employees]);



    // Fetch Employees
    const fetchEmployees = async () => {
        try {
            const response = await axiosInstance.get("/employee/");
            console.log(response.data)
            setEmployees(response.data);
        } catch (error) {
            console.error("Error fetching Employees:", error);
        }
    };

    // Fetch Employees from API
    useEffect(() => {
        fetchEmployees();
    }, []);

    return (
        <div>
            {/* Page Wrapper */}
            <div class="page-wrapper">
                <div class="content container-fluid">
                    {/* Page Header */}
                    <div class="page-header">
                        <div class="content-page-header">
                            <h5>Customers</h5>
                            <div class="list-btn">
                                <ul class="filter-list">
                                    <li>
                                        <a class="btn btn-filters w-auto popup-toggle" data-bs-toggle="tooltip"
                                            data-bs-placement="bottom" title="Filter"><span class="me-2"><img src="assets/img/icons/filter-icon.svg" alt="filter" /></span>Filter </a>
                                    </li>
                                    <li>
                                        <div class="dropdown dropdown-action" data-bs-toggle="tooltip" data-bs-placement="top" title="Download">
                                            <a href="#" class="btn-filters" data-bs-toggle="dropdown" aria-expanded="false"><span><i class="fe fe-download"></i></span></a>
                                            <div class="dropdown-menu dropdown-menu-end">
                                                <ul class="d-block">
                                                    <li>
                                                        <a class="d-flex align-items-center download-item" href="javascript:void(0);" download><i class="far fa-file-pdf me-2"></i>PDF</a>
                                                    </li>
                                                    <li>
                                                        <a class="d-flex align-items-center download-item" href="javascript:void(0);" download><i class="far fa-file-text me-2"></i>CVS</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <a class="btn-filters" href="javascript:void(0);" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Print"><span><i class="fe fe-printer"></i></span> </a>
                                    </li>
                                    <li>
                                        <a class="btn btn-import" href="javascript:void(0);"><span><i class="fe fe-check-square me-2"></i>Import Customer</span></a>
                                    </li>
                                    <li>
                                        <a class="btn btn-primary" href="/add-employee"><i class="fa fa-plus-circle me-2" aria-hidden="true"></i>Add Customer</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    {/* /Page Header */}

                    {/* Search Filter */}
                    <div id="filter_inputs" class="card filter-card">
                        <div class="card-body pb-0">
                            <div class="row">
                                <div class="col-sm-6 col-md-3">
                                    <div class="input-block mb-3">
                                        <label>Name</label>
                                        <input type="text" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-sm-6 col-md-3">
                                    <div class="input-block mb-3">
                                        <label>Email</label>
                                        <input type="text" class="form-control" />
                                    </div>
                                </div>
                                <div class="col-sm-6 col-md-3">
                                    <div class="input-block mb-3">
                                        <label>Phone</label>
                                        <input type="text" class="form-control" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /Search Filter */}

                    {/* Table */}
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card-table">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <table className="table table-center table-hover datatable">
                                            <thead className="thead-light">
                                                <tr>
                                                    <th>#</th>
                                                    <th>Employee Name</th>
                                                    <th>Phone</th>
                                                    <th>Role</th>
                                                    <th>Department</th>
                                                    <th>City</th>
                                                    <th className="no-sort">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {employees.length > 0 ? (
                                                    employees.map((employee, index) => {
                                                        return (
                                                            <tr key={employee.id}>
                                                                <td>{index + 1}</td>
                                                                <td>{employee.firstName} {employee.lastName}</td>
                                                                <td>{employee.phone}</td>
                                                                <td>{employee.jobTitle}</td>
                                                                <td>{employee.department}</td>
                                                                <td>{employee.city}</td>
                                                                <td className="d-flex align-items-center">
                                                                    <button
                                                                        className="btn btn-greys bg-success-light me-2"
                                                                        data-bs-toggle="modal"
                                                                        data-bs-target="#edit_product"
                                                                        
                                                                    >
                                                                        <i className="fa fa-edit me-1"></i>Edit
                                                                    </button>
                                                                    <button
                                                                        className="btn btn-greys bg-danger-light me-2"
                                                                        data-bs-toggle="modal"
                                                                        data-bs-target="#delete_product"
                                                                        
                                                                    >
                                                                        <i className="fa fa-trash-alt me-1"></i> Delete
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan="5" className="text-center">
                                                            No Products found
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /Table */}
                </div>
                <Footer />
            </div>
            {/* /Page Wrapper */}
        </div>

    )
}

export default Employee